import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as helperStyles } from '../../../../assets/style-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpers } from '../../../../assets/flexbox-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${helperStyles}`),
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${componentStyles}`),
  unsafeCSS(`${widgetSharedStyles}`),
  unsafeCSS(`${flexboxHelpers}`),
];
